import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  imaegButton: 'data-image-button',
  imageDropdown: 'data-image-dropdown',
}
const qsAll = {
  sections: 'data-section-type="custom-text"',
}

const initSection = (section) => {
  const imaegButton = section.querySelector(`[${qs.imaegButton}]`)
  if(imaegButton) {
    const imageDropdown = section.querySelector(`[${qs.imageDropdown}]`)
    imaegButton.addEventListener('click', () => {
      imaegButton.classList.toggle('button--secondary')
      imaegButton.classList.toggle('button--primary__filled')
      imageDropdown.classList.toggle('hidden')
    })
  }
}

export const setupCustomTexts = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}